import { useEffect } from 'react';

// Modal do portal: fundo escuro, fecha no Esc e no clique fora.
// O rodapé vem de quem usa, com botões de nome explícito (nunca um "Fechar" ambíguo).
export default function Modal({ titulo, aberto, onFechar, children, rodape, largura = 520 }) {
  useEffect(() => {
    if (!aberto) return undefined;
    const esc = (e) => { if (e.key === 'Escape') onFechar(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [aberto, onFechar]);

  if (!aberto) return null;
  return (
    <div className="pc-modal-fundo" onMouseDown={onFechar}>
      <div className="pc-modal" style={{ width: `min(${largura}px, 100%)` }} role="dialog" aria-modal="true"
           onMouseDown={e => e.stopPropagation()}>
        <div className="pc-modal-cab">
          <h2>{titulo}</h2>
          <button type="button" className="btn-close" onClick={onFechar} aria-label="Cancelar" />
        </div>
        <div className="pc-modal-corpo">{children}</div>
        {rodape && <div className="pc-modal-rodape">{rodape}</div>}
      </div>
    </div>
  );
}
